import React from "react";
import {Box, Card, Divider, Stack, Typography} from "@mui/material";
import {calculateReduction, calculateSubtotal, formatCurrency, formatDateISOSmall} from "../../utils/helpers";


export default function ProductCard({products}) {

    return (
        <React.Fragment>
            <Card variant="outlined" sx={{p: 1, mb: 1, borderRadius: '0 0 8px 8px'}}>
                {products.map((product, index) => {
                    return <React.Fragment key={index}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', md: 'row'},
                            justifyContent: 'space-between'
                        }}>
                            <Box>
                                <Typography variant="body2" fontWeight="bold">
                                    {product.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {formatDateISOSmall(product.datetimeStart)} →{" "}
                                    {formatDateISOSmall(product.datetimeEnd)}
                                </Typography>
                            </Box>
                            <Stack
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end',
                                    gap: 1
                                }}
                            >
                                <Typography
                                    variant="body2">{product.quantity}× {formatCurrency(product.price)}</Typography>
                                <Typography variant="body2" sx={{textAlign: 'right'}}>
                                    {formatCurrency(product.price * product.quantity)}
                                </Typography>
                            </Stack>
                        </Box>

                        {/* Affichage des options sous la même forme que le produit, avec le nom, prix et quantité */}
                        {product.options.map((option, index) => (
                            <Box key={index} mt={1} sx={{pl: 1, borderLeft: '2px solid', borderColor: 'grey.300'}}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: {xs: 'column', md: 'row'},
                                    justifyContent: 'space-between'
                                }}>
                                    <Typography variant="body2" fontWeight="bold">
                                        {option.name}
                                    </Typography>
                                    <Stack
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-end',
                                            gap: 1
                                        }}
                                    >
                                        <Typography
                                            variant="body2">{option.quantity}× {formatCurrency(option.price)}</Typography>
                                        <Typography variant="body2"
                                                    sx={{textAlign: 'right'}}>
                                            {formatCurrency(option.price * option.quantity)}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </Box>
                        ))}

                        {/* Affichage des réductions */}
                        {product.discountType !== 'none' && product.discountValue > 0 && (
                            <React.Fragment>
                                <Stack direction="row" justifyContent="space-between"
                                       alignItems="center" sx={{mt: 1}}>
                                    <Typography variant="body2" color="text.secondary">
                                        Réduction :
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        - {formatCurrency(calculateReduction(product.price, product.quantity, product.discountType, product.discountValue, product.options))}
                                    </Typography>
                                </Stack>
                            </React.Fragment>
                        )}

                        <Divider sx={{my: 1}}/>
                    </React.Fragment>
                })}


                {/* Affichage du sous-total */}
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" fontWeight="bold" color="primary">
                        Sous-total TTC :
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" color="primary">
                        {formatCurrency(calculateSubtotal(products))}
                    </Typography>
                </Stack>
            </Card>
        </React.Fragment>
    )
}